import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
// TODO - fix this import when we can import thunderbolt-commmons properly
import { getImpliedLinks } from '@wix/thunderbolt-commons/dist/links';
import type {
  WRichTextDefinition,
  WRichTextProps,
} from '@wix/thunderbolt-components';
// TODO - import this directly from '@wix/thunderbolt-components'
import type {
  WRichTextCSSVars as OriginalWRichTextCSSVars,
  WRichTextSdkData as OriginalWRichTextSdkData,
} from '@wix/thunderbolt-components/dist/components/WRichText/WRichText';
import {
  sanitizeHTML,
  isExperimentOpen,
} from '@wix/editor-elements-common-utils';

import { flow } from '../corvid/utils';
import { injectTextSemanticClassName } from '../utils';
import type { WRichTextSdkData } from '../WRichText.types';

export const props = withCompInfo<
  WRichTextProps,
  WRichTextDefinition,
  WRichTextProps
>()(
  ['isMobileView', 'isQaMode', 'fullNameCompType'],
  ({ isMobileView, isQaMode, fullNameCompType }, carmiData) => {
    const htmlWithLinks = flow(
      html => getImpliedLinks(html, isMobileView),
      sanitizeHTML,
    )(carmiData.html);
    const htmlWithSemanticClasses = injectTextSemanticClassName(htmlWithLinks);
    return {
      ...carmiData,
      html: htmlWithSemanticClasses,
      isQaMode,
      fullNameCompType,
    };
  },
);

export type WRichTextCSSVars = Omit<OriginalWRichTextCSSVars, 'min-width'> & {
  '--min-width'?: string;
  '--text-direction'?: string;
};

export const css = withCompInfo<
  WRichTextCSSVars,
  WRichTextDefinition,
  WRichTextCSSVars
>()([], (_deps, carmiCss) => {
  const { 'min-width': minWidth, direction, ...cssVars } = carmiCss;

  return {
    ...cssVars,
    ...(minWidth && { '--min-width': minWidth }),
    ...(direction && { '--text-direction': direction }),
  };
});

// Should be removed after the specs.thunderbolt.WRichTextVerticalAlignTopSafariAndIOS experiment is open to 100%
const stateRefs = withStateRefsValues(['experiments']);

export const sdkData = withCompInfo<
  WRichTextSdkData,
  WRichTextDefinition,
  OriginalWRichTextSdkData
>()(['experiments'], ({ experiments }, carmiData) => {
  return {
    ...carmiData,
    shouldAttachSemanticClassNames: isExperimentOpen(
      experiments,
      'specs.thunderbolt.updateRichTextSemanticClassNamesOnCorvid',
    ),
  };
});

export default createComponentMapperModel({ props, stateRefs, sdkData });
